import React from 'react';
import { Link } from 'react-router-dom';

const BlogFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="blog-footer">
      <div className="footer-content">
        <div className="footer-links">
          <Link to="/">Home</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
        <div className="footer-copyright">
          &copy; {currentYear} PLAB2 Simulator. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default BlogFooter; 